import React, { useState, useRef, useEffect } from "react";
import HGraph from "components/Custom/HGraph";

import { FORMATS, GRAPH_TYPES } from "common/config";
import { REPORTS_APIs } from "apihandlers/reports";
import SkeletonBox from "components/Custom/SkeletonBox";

import HighCharts from "highcharts";
import Drilldown from "highcharts/modules/drilldown";
import TreeMap from "highcharts/modules/treemap";
import TreeGraph from "highcharts/modules/treegraph";

Drilldown(HighCharts);
//TODO: Treegraph module not working!. Problem with the package.
TreeMap(HighCharts);
TreeGraph(HighCharts);

const RsmView = () => {
  const [loading, setLoading] = useState(false);
  const [rsmCharts, setRsmCharts] = useState(null);
  const [asmCharts, setAsmCharts] = useState(null);
  const [seCharts, setSeCharts] = useState(null);
  const [soCharts, setSoCharts] = useState(null);
  const [srCharts, setSrCharts] = useState(null);

  const [barChartSeries, setBarChartSeries] = useState(null);
  const [barChartCategories, setBarChartCategories] = useState(null);

  const [drillChartSeries, setDrillChartSeries] = useState(null);
  const [drillChartDrilldown, setDrillChartDrilldown] = useState(null);

  useEffect(() => {
    getRsmPieChart();
    getRsmBarChart();
    getRsmDrillChart();
  }, [loading]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 8000);
  });

  const rsmChart = [
    {
      name: "RSM",
      data: rsmCharts,
    },
  ];

  const asmChart = [
    {
      name: "ASM",
      data: asmCharts,
    },
  ];

  const seChart = [
    {
      name: "SE",
      data: seCharts,
    },
  ];

  const soChart = [
    {
      name: "SO",
      data: soCharts,
    },
  ];
  const srChart = [
    {
      name: "SR",
      data: srCharts,
    },
  ];

  const getRsmPieChart = async () => {
    try {
      const args = {};
      const res = await REPORTS_APIs.getRsmPieChartData(args);
      const response: any = res.response;
      const { status } = res;

      setRsmCharts(response.rsmPieChart[0].data);
      setAsmCharts(response.asmPieChart[0].data);
      setSeCharts(response.sePieChart[0].data);
      setSoCharts(response.soPieChart[0].data);
      setSrCharts(response.srPieChart[0].data);
    } catch (err) {
      console.log("error", err);
    }
  };

  const getRsmBarChart = async () => {
    try {
      const args = {};
      const res = await REPORTS_APIs.getRsmBarChartData(args);
      const response: any = res.response;
      const { status } = res;

      setBarChartSeries(response.customerBarChartData.data);
      setBarChartCategories(response.customerBarChartData.category);
    } catch (err) {
      console.log("error", err);
    }
  };

  const getRsmDrillChart = async () => {
    try {
      const args = {};
      const res = await REPORTS_APIs.getRsmDrilldownChartData(args);
      const response: any = res.response;
      const { status } = res;

      setDrillChartSeries(response.rsmDrillChartData.data);
      setDrillChartDrilldown(response.rsmDrillChartData.drilldown.data);
    } catch (err) {
      console.log("error", err);
    }
  };
  console.log("series", drillChartSeries);
  console.log("drilldown", drillChartDrilldown);

  const customerBarChart = {
    chart: {
      type: "bar",
    },
    title: {
      text: "Top Performers in Six Months",
    },
    xAxis: {
      categories: barChartCategories,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    legend: {
      reversed: false,
    },
    credits: false,
    plotOptions: {
      series: {
        stacking: "normal",
        pointWidth: 17,
        groupPadding: 0.4,
        pointPadding: 0.1,
        dataLabels: {
          enabled: true,
          align: "right",
        },
      },
    },
    series: barChartSeries,
  };

  const rsmDrillDownChart = {
    chart: {
      type: "column",
    },
    title: {
      text: "RSM Drilldown Chart",
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      title: {
        text: "Value",
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
      },
    },
    credits: false,
    series: [
      {
        name: "RSM",
        colorByPoint: true,
        data: drillChartSeries,
      },
    ],
    drilldown: {
      series: drillChartDrilldown,
    },
  };

  const treedata = [
    {
      id: "0.0",
      parent: "",
      name: "The World",
    },
    {
      id: "1.3",
      parent: "0.0",
      name: "Asia",
    },
    {
      id: "1.1",
      parent: "0.0",
      name: "Africa",
    },
    {
      id: "1.2",
      parent: "0.0",
      name: "America",
    },
    {
      id: "1.4",
      parent: "0.0",
      name: "Europe",
    },
    {
      id: "1.5",
      parent: "0.0",
      name: "Oceanic",
    },

    /* Africa */
    {
      id: "2.1",
      parent: "1.1",
      name: "Eastern Africa",
    },

    {
      id: "2.5",
      parent: "1.1",
      name: "Western Africa",
    },

    {
      id: "2.3",
      parent: "1.1",
      name: "North Africa",
    },

    {
      id: "2.2",
      parent: "1.1",
      name: "Central Africa",
    },

    {
      id: "2.4",
      parent: "1.1",
      name: "South America",
    },

    /* America */
    {
      id: "2.9",
      parent: "1.2",
      name: "South America",
    },

    {
      id: "2.8",
      parent: "1.2",
      name: "Northern America",
    },

    {
      id: "2.7",
      parent: "1.2",
      name: "Central America",
    },

    {
      id: "2.6",
      parent: "1.2",
      name: "Caribbean",
    },

    /* Asia */
    {
      id: "2.13",
      parent: "1.3",
      name: "Southern Asia",
    },

    {
      id: "2.11",
      parent: "1.3",
      name: "Eastern Asia",
    },

    {
      id: "2.12",
      parent: "1.3",
      name: "South-Eastern Asia",
    },

    {
      id: "2.14",
      parent: "1.3",
      name: "Western Asia",
    },

    {
      id: "2.10",
      parent: "1.3",
      name: "Central Asia",
    },

    /* Europe */
    {
      id: "2.15",
      parent: "1.4",
      name: "Eastern Europe",
    },

    {
      id: "2.16",
      parent: "1.4",
      name: "Northern Europe",
    },

    {
      id: "2.17",
      parent: "1.4",
      name: "Southern Europe",
    },

    {
      id: "2.18",
      parent: "1.4",
      name: "Western Europe",
    },
    /* Oceania */
    {
      id: "2.19",
      parent: "1.5",
      name: "Australia and New Zealand",
    },

    {
      id: "2.20",
      parent: "1.5",
      name: "Melanesia",
    },

    {
      id: "2.21",
      parent: "1.5",
      name: "Micronesia",
    },

    {
      id: "2.22",
      parent: "1.5",
      name: "Polynesia",
    },
  ];

  const treeGraph = {
    title: {
      text: "Treegraph with box layout",
      height: 600,
    },
    series: [
      {
        type: "treegraph",

        tooltip: {
          pointFormat: "{point.name}",
        },
        marker: {
          symbol: "rect",
          width: "25%",
        },
        credits: false,
        borderRadius: 10,
        heigth: "25%",
        dataLabels: {
          pointFormat: "{point.name}",
          style: {
            whiteSpace: "nowrap",
          },
        },
        data: treedata,
        levels: [
          {
            level: 1,
            levelIsConstant: false,
          },
          {
            level: 2,
            colorByPoint: true,
          },
          {
            level: 3,
            colorVariation: {
              key: "brightness",
              to: -0.5,
            },
          },
          {
            level: 4,
            colorVariation: {
              key: "brightness",
              to: 0.5,
            },
          },
        ],
      },
    ],
  };

  return loading ? (
    <>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingLeft: "17px",
        }}
      >
        <div className="graphDashboard">
          <SkeletonBox
            height={350}
            width={"90%"}
            style={{ borderRadius: "1rem" }}
          />
        </div>
        <div className="graphDashboard">
          <SkeletonBox
            height={350}
            width={"90%"}
            style={{ borderRadius: "1rem" }}
          />
        </div>
        <div className="graphDashboard">
          <SkeletonBox
            height={350}
            width={"90%"}
            style={{ borderRadius: "1rem" }}
          />
        </div>
      </div>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingLeft: "17px",
          paddingTop: "2rem",
        }}
      >
        <div className="graphDashboard">
          <SkeletonBox
            height={350}
            width={"63%"}
            style={{ borderRadius: "1rem" }}
          />
        </div>
        <div className="graphDashboard">
          <SkeletonBox
            height={350}
            width={"63%"}
            style={{
              borderRadius: "1rem",
              position: "relative",
              right: "15rem",
            }}
          />
        </div>
      </div>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          left: "30px",
          paddingTop: "2rem",
        }}
      >
        <SkeletonBox
          height={450}
          width={"97%"}
          style={{ left: "17px", borderRadius: "1rem" }}
        />
      </div>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          left: "30px",
          paddingTop: "2rem",
        }}
      >
        <SkeletonBox
          height={400}
          width={"97%"}
          style={{ paddingBottom: "2rem", left: "17px", borderRadius: "1rem" }}
        />
      </div>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          left: "30px",
          paddingTop: "2rem",
        }}
      >
        <SkeletonBox
          height={450}
          width={"97%"}
          style={{ marginBottom: "2rem", left: "17px", borderRadius: "1rem" }}
        />
      </div>
    </>
  ) : (
    <>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingLeft: "17px",
        }}
      >
        <div className="graphDashboard ">
          <HGraph
            title={"RSM"}
            type={GRAPH_TYPES.PIE}
            series={rsmChart}
            exportTitle={"Chart"}
            width={"90%"}
            height={"70%"}
            options={""}
          />
        </div>
        <div className="graphDashboard ">
          <HGraph
            title={"ASM"}
            type={GRAPH_TYPES.PIE}
            series={asmChart}
            exportTitle={"Chart"}
            width={"90%"}
            height={"70%"}
            options={""}
          />
        </div>
        <div className="graphDashboard ">
          <HGraph
            title={"SE"}
            type={GRAPH_TYPES.PIE}
            series={seChart}
            exportTitle={"Chart"}
            width={"90%"}
            height={"70%"}
            options={""}
          />
        </div>
      </div>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingLeft: "17px",
          paddingTop: "2rem",
        }}
      >
        <div className="graphDashboard ">
          <HGraph
            title={"SO"}
            type={GRAPH_TYPES.PIE}
            series={soChart}
            exportTitle={"Chart"}
            width={"63%"}
            height={"70%"}
            options={""}
          />
        </div>
        <div
          className="graphDashboard "
          style={{ position: "relative", right: "15rem" }}
        >
          <HGraph
            title={"SR"}
            type={GRAPH_TYPES.PIE}
            series={srChart}
            exportTitle={"Chart"}
            width={"63%"}
            height={"70%"}
            options={""}
          />
        </div>
      </div>

      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          left: "30px",
          paddingTop: "2rem",
        }}
      >
        <div className="graphDashboard " style={{ width: "97%", left: "17px" }}>
          <HGraph
            width={"100%"}
            height={"100%"}
            type={GRAPH_TYPES.BAR}
            float={"right"}
            title={"Column Graph"}
            exportTitle={"Column Graph Record"}
            xAxisTitle=""
            yAxisTitle="Leads"
            graphData={customerBarChart}
          />
        </div>
      </div>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          left: "30px",
          paddingTop: "2rem",
        }}
      >
        <div
          className="graphDashboard "
          style={{ paddingBottom: "2rem", width: "97%", left: "17px" }}
        >
          <HGraph
            width={"100%"}
            height={"100%"}
            type={GRAPH_TYPES.COLUMN}
            float={"right"}
            title={"Column Graph"}
            exportTitle={"Column Graph Record"}
            xAxisTitle=""
            yAxisTitle="Leads"
            graphData={rsmDrillDownChart}
          />
        </div>
      </div>
      <div
        className="graphContainer"
        style={{
          display: "flex",
          flexDirection: "row",
          left: "30px",
          paddingTop: "2rem",
        }}
      >
        <div
          className="graphDashboard "
          style={{
            paddingBottom: "2rem",
            width: "97%",
            left: "17px",
          }}
        >
          <HGraph
            width={"100%"}
            height={"100%"}
            float={"right"}
            title={"Column Graph"}
            exportTitle={"Column Graph Record"}
            xAxisTitle=""
            yAxisTitle="Leads"
            graphData={treeGraph}
          />
        </div>
      </div>
    </>
  );
};

export default RsmView;
